import { Address } from 'viem';

export const tBtcTokenAddress: Address = '0x18084fbA666a33d37592fA2633fD49a74DD93a88';
